import React from "react";
import { Container } from "react-bootstrap";
import "../css/strip.css";

export default function Strip() {
  return (
    <section className="prefooter-texture">
      <Container>{/* volutamente vuoto, solo decorativo */}</Container>
    </section>
  );
}
